import { PAGE_SCORE_AREAS } from '../../../types/product'
import type { PageScoreAreaId, ProductPageScoreAreaResult } from '../../../types/product'

// Normalises the backend `page_score` list field. Only a finite number is
// accepted; a missing value, a string, NaN or Infinity all map to undefined
// so the list renders its "—" placeholder instead of a bogus score.
export const parsePageScore = (value: unknown): number | undefined =>
  typeof value === 'number' && Number.isFinite(value) ? value : undefined

const AREA_IDS: readonly string[] = PAGE_SCORE_AREAS

// Normalises the backend `page_score_data` list field into its per-area
// breakdown. Returns undefined when the object or its `areas` array is
// missing/malformed; individual entries with an unknown id or a non-finite
// value are dropped, and non-string issues are ignored.
export const parsePageScoreAreas = (raw: unknown): ProductPageScoreAreaResult[] | undefined => {
  if (!raw || typeof raw !== 'object') return undefined
  const areas = (raw as { areas?: unknown }).areas
  if (!Array.isArray(areas)) return undefined
  const parsed = areas.flatMap((entry): ProductPageScoreAreaResult[] => {
    if (!entry || typeof entry !== 'object') return []
    const { id, value, status, issues } = entry as Record<string, unknown>
    if (typeof id !== 'string' || !AREA_IDS.includes(id)) return []
    if (typeof value !== 'number' || !Number.isFinite(value)) return []
    return [
      {
        id: id as PageScoreAreaId,
        value: Math.min(1, Math.max(0, value)),
        status: typeof status === 'string' ? status : '',
        issues: Array.isArray(issues) ? issues.filter((i): i is string => typeof i === 'string' && !!i.trim()) : [],
      },
    ]
  })
  return parsed.length ? parsed : undefined
}
